import { __decorate } from "tslib";
import { Action, Getter, Mutation, State } from "@/types";
import { service } from "@/services";
export class SystemEventsSourcesModule {
    constructor() {
        this.systemEventsSources = [];
        this.count = 0;
        this.axiosError = null;
    }
    setItems(systemEventsSource) {
        this.systemEventsSources = systemEventsSource;
    }
    setTotal(count) {
        this.count = count;
    }
    setError(error) {
        this.axiosError = error;
    }
    get list() {
        return this.systemEventsSources;
    }
    get total() {
        return this.count;
    }
    get errorList() {
        return this.axiosError;
    }
    async get(options) {
        try {
            const data = await service.systemEventsSources.get(options);
            this.setItems(data.items);
            this.setTotal(data.total);
        }
        catch (error) {
            this.setError(error);
            // push into Notice
            // server text error - "error.response.data.message"
            // or default error - "error.response.statusText"
            // or custom error message
            // or return Promise.reject(error)
        }
    }
}
__decorate([
    State()
], SystemEventsSourcesModule.prototype, "systemEventsSources", void 0);
__decorate([
    State()
], SystemEventsSourcesModule.prototype, "count", void 0);
__decorate([
    State()
], SystemEventsSourcesModule.prototype, "axiosError", void 0);
__decorate([
    Mutation()
], SystemEventsSourcesModule.prototype, "setItems", null);
__decorate([
    Mutation()
], SystemEventsSourcesModule.prototype, "setTotal", null);
__decorate([
    Mutation()
], SystemEventsSourcesModule.prototype, "setError", null);
__decorate([
    Getter()
], SystemEventsSourcesModule.prototype, "list", null);
__decorate([
    Getter()
], SystemEventsSourcesModule.prototype, "total", null);
__decorate([
    Getter()
], SystemEventsSourcesModule.prototype, "errorList", null);
__decorate([
    Action()
], SystemEventsSourcesModule.prototype, "get", null);
